import React from "react";
import slideKickGotoBtn from "../../../../../assets/images/slideKick/right-chev.png";
import cx from "classnames";
import { connect } from "react-redux";
import _ from "lodash";

const BottomNav = ({
  paramsReducer,
  change_slide,
  handle_go_to_slide,
  current_slide,
  total_pages,
  goto_disable,
}) => {
  function previousPage() {
    change_slide("previous");
  }

  function nextPage() {
    change_slide("next");
  }
  const go_to_slide_button = _.get(
    paramsReducer,
    "gameObj.presenting.go_to_slide_button",
    "Go to Slide",
  );
  return (
    <div className="footer-container">
      <div className="upper-footer">
        <button
          onClick={handle_go_to_slide}
          disabled={goto_disable}
          className={cx("btn btn-goto", {
            disabled: goto_disable,
          })}
        >
          {go_to_slide_button}
        </button>
      </div>
      <div className="footer">
        <div className="button-container">
          <button
            className={cx("btn-left", {
              disabled: current_slide <= 1,
            })}
            disabled={current_slide <= 1}
            onClick={previousPage}
          >
            <img
              alt=""
              // disabled={activeIndex === 0 ? true : false}
              src={slideKickGotoBtn}
            />
          </button>
          <button
            className={cx("btn-right", {
              disabled: current_slide >= total_pages,
            })}
            disabled={current_slide >= total_pages}
            onClick={nextPage}
          >
            <img alt="" src={slideKickGotoBtn} />
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(BottomNav);
